import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

import Notification from "../../screens/Notification";

import {fetchnotifications,updateNotification,NotificationPageSelected, shownNotifications/* ,unreadnotifications */} from "./action";

class NotificationContainer extends Component {
  render() {
    return <Notification 
      fetchnotifications={this.props.fetchnotifications}
      notifications={this.props.notifications}
      notificationCount={this.props.notificationCount}
      updateNotification={this.props.updateNotification}
      NotificationPageSelected={this.props.NotificationPageSelected}
      /* unreadnotificationCount={this.props.unreadnotificationCount} */
      shownNotifications={this.props.shownNotifications}
      /* shownnotificationsdata={this.props.shownnotificationsdata}
      shownnotificationsCount={this.props.shownnotificationsCount} */
    />;
  }
}
function bindAction(dispatch) {
  return {
    fetchnotifications:(value)=>{
      dispatch(fetchnotifications(value));
    },
    updateNotification:(value)=>{
      dispatch(updateNotification(value));
    },
    NotificationPageSelected:(value)=>{
      dispatch(NotificationPageSelected(value))
    },
    /* unreadnotifications:()=>{
      dispatch(unreadnotifications());
    }, */
    shownNotifications:()=>{
      dispatch(shownNotifications());
    },
  };
}

const mapStateToProps = state => {
  return {
    notifications:state.NotificationsReducer.notifications,
    notificationCount:state.NotificationsReducer.notificationCount,
    /* unreadnotificationcount:state.NotificationsReducer.unreadnotificationCount, */
    shownnotificationsCount:state.NotificationsReducer.shownnotificationsCount,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(NotificationContainer);
